import { z } from 'zod';

export const vroomPostMessageSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('unknown'),
  }),
  z.object({
    type: z.literal('user_navigated'),
    data: z.object({
      url: z.string(),
    }),
  }),
]);
